import axios from 'axios';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/**
 * Convert raw form data into an object for AJAX request.
 *
 * @param {Element} form The form element
 * @returns {} Key-value pair of form elements and values
 */
const processFormElements = (form) => {
  const formElements = Array.from(form.elements).filter((element) => element.type !== 'submit');
  const processedFormElements = {};

  formElements.forEach((element) => {
    if (element.id === 'GDPR') {
      if (element.value === 'on') {
        processedFormElements[element.id] = 'True';
      } else {
        processedFormElements[element.id] = 'False';
      }
    } else {
      processedFormElements[element.id] = element.value;
    }
  });

  return processedFormElements;
};

/**
 * Overlay Helpers.
 */
const openOverlay = (overlay) => {
  const openTimeline = gsap.timeline();
  openTimeline
    .to(overlay, {
      autoAlpha: 1,
      display: 'block',
      duration: 0.2,
      onComplete() {
        gsap.set(document.body, { overflow: 'hidden' });
      },
    });
};
const closeOverlay = (overlay) => {
  const closeTimeline = gsap.timeline();
  closeTimeline
    .to(overlay, {
      autoAlpha: 0,
      display: 'none',
      duration: 0.2,
      onComplete() {
        gsap.set(document.body, { overflow: 'auto' });
      },
    });
};

/**
 * Open/Close overlay.
 */
const overlay = document.getElementById('stay-informed');
const overlayOpenTrigger = document.querySelector('.site-header__nav-item:last-of-type .site-header__nav-link');
const overlayOpenTriggerCTA = document.querySelector('.stay-informed-callout a.button');
const overlayCloseTrigger = document.querySelector('.stay-informed__close');
overlayOpenTrigger.addEventListener('click', (e) => {
  e.preventDefault();
  openOverlay(overlay);
});
overlayOpenTriggerCTA.addEventListener('click', (e) => {
  e.preventDefault();
  openOverlay(overlay);
});
overlayCloseTrigger.addEventListener('click', (e) => {
  e.preventDefault();
  closeOverlay(overlay);
});

/**
 * Form submissions.
 */
const form = document.querySelector('.stay-informed__form');
const thankYouMessage = document.querySelector('.stay-informed__thank-you');

gsap.set(thankYouMessage, {
  autoAlpha: 0,
  display: 'none',
});

/**
 * Submit form data to Pardot.
 */
form.addEventListener('submit', (e) => {
  e.preventDefault();

  const action = form.getAttribute('action');

  grecaptcha.ready(() => {
    grecaptcha
      .execute('6LeR2JoqAAAAAFLACSzq4iZnTF03Myag7p3kgwwd', { action: 'submit' })
      .then((token) => {
        const recaptchaResponse = document.getElementById('recaptchaResponse');
        recaptchaResponse.value = token;
        const formData = processFormElements(form);
        const formDataField = document.getElementById('formData');
        formDataField.value = formData;

        axios({
          method: 'post',
          url: '/proxy.php',
          data: {
            action,
            ...formData,
          },
        })
          .then((response) => {
            // console.log('response data: ', response.data);
            overlayCloseTrigger.classList.remove('stay-informed__close--abandon');
            overlayCloseTrigger.classList.add('stay-informed__close--success');
            gsap.timeline()
              .to(form, {
                autoAlpha: 0,
                height: 0,
                display: 'none',
                duration: 0.3,
              })
              .to(thankYouMessage, {
                autoAlpha: 1,
                display: 'block',
                duration: 0.3,
              });
          })
          .catch((error) => {
            console.log(`error: ${error}`);
            const recaptchaError = document.querySelector('#recaptchaFailError');
            recaptchaError.style.display = 'block';
          });
      });
  });

  grecaptcha.reset();// to reset their widget for any other tries
});

/**
 * Trigger overlay at the bottom of page.
 */
// let hasVisitedOverlay = false;
// ScrollTrigger.create({
//   trigger: '.site-footer',
//   start: 'top center',
//   onEnter() {
//     if (!hasVisitedOverlay) {
//       openOverlay(overlay);
//       hasVisitedOverlay = true;
//     }
//   },
// });

/**
 * Open overlay if url has anchor
 */
const domReady = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
};

domReady(() => {
  if (window.location.hash === '#stay-informed') {
    openOverlay(overlay);
  }
});
